const frequenciesJson = require("assets/freq.json");

export const getFrequency = (hanzi: string) => {
  const frequencies = frequenciesJson["per_1M"];
  return frequencies[hanzi] || 2;
};

export default getFrequency;
